module.exports = __webpack_public_path__ + "static/32-3837a66e42e5a36a281d411f007b8e6c.jpg";